export const Fonts = {
  ttNormsProNormal: "TTNormsPro-Normal",
  ttNormsProBold: "TTNormsPro-Bd",
  ttNormsProItalic: "TTNormsPro-It",
  sourceSerifProBold: "SourceSerifPro-Bold",
  sourceSerifProExtraLight: "SourceSerifPro-ExtraLight",
  rossanovaBold: "RossanovaBold",
};

export type FontsType = typeof Fonts;
export type KeyFonts = keyof FontsType;
